import React, { useContext } from 'react';
import BookerContext from '../../context/bookerContext';
import { getDateFormat } from '../../utils/dateFormat';
import Rating from './Rating';
import { ReactComponent as CloseIcon } from '../../assets/img/close.svg';
import { ReactComponent as ArrowIcon } from '../../assets/img/arrow.svg';
import '../../assets/styles/ride-history.sass';

const RideDetailsHistory = ({ closeRideHistoryHandler }) => {
  const context = useContext(BookerContext);
  const {
    state: { rideDetailsHistory },
    updateRideDetailsHistory,
    updateRideDetailsReceipt,
  } = context;

  const isCanceledRide = rideDetailsHistory.ride_status_code === 'canceled';

  const receiptClickHandler = () => {
    updateRideDetailsReceipt(rideDetailsHistory);
  };

  const onBackHandler = () => {
    updateRideDetailsHistory(null);
  };

  const address = [
    {
      id: 'pickup',
      label: `Pickup ${getDateFormat(rideDetailsHistory.pickup_time_local, 'h:mm aa')}`,
      visible: true,
      location: rideDetailsHistory.pickup_location,
    },
    {
      id: 'dropoff',
      label: `Destination ${getDateFormat(rideDetailsHistory.dropoff_time_local, 'h:mm aa')}`,
      visible: rideDetailsHistory.dropoff_location,
      location: rideDetailsHistory.dropoff_location,
    },
  ];

  const rideParams = [
    {
      id: 'rideType',
      label: `Ride Type`,
      value: rideDetailsHistory.service_type,
    },
    {
      id: 'taxiNumber',
      label: `Taxi #`,
      value: rideDetailsHistory.vehicle_number || '-',
    },
    {
      id: 'confirmationNumber',
      label: `Confirmation #`,
      value: rideDetailsHistory.confirmation_number,
    },
    {
      id: 'driverName',
      label: 'Driver Name',
      value: rideDetailsHistory.driver_name || '-',
    },
  ];

  return (
    <div className="form-group ride-details-history-container">
      <div className="details-container">
        <div className="details-header">
          <ArrowIcon onClick={onBackHandler} className="arrow-history" />
          <div className="title">{getDateFormat(rideDetailsHistory.pickup_time_local, `MMMM d, yyyy`)}</div>
          <CloseIcon className="details-hide-icon" onClick={closeRideHistoryHandler} />
        </div>
        <div className="total">{rideDetailsHistory.total_formatted}</div>

        <div className="address">
          {address.map(
            item =>
              item.visible && (
                <div className="address-line" key={item.id}>
                  <div className="address-label">
                    <span className={`history-dot ${item.id}-dot`} />
                    {item.label}
                  </div>
                  <div className="address-value">{item.location}</div>
                </div>
              ),
          )}
        </div>

        {rideParams.map(item => (
          <div key={item.id}>
            <div className="details-label">{item.label}</div>
            <div className="details-value">{item.value}</div>
          </div>
        ))}

        <div className="details-label">Your Ride Rating</div>
        <Rating rateLevelAmount={5} rating={rideDetailsHistory.rating} />
      </div>
      {!isCanceledRide && (
        <div className="see-receipt-container">
          <span onClick={receiptClickHandler}>See Receipt</span>
        </div>
      )}
    </div>
  );
};

export default RideDetailsHistory;
